import { useState } from 'react';
import {
  FormAndFieldsState,
  FormState,
  FormStateSetter,
  FormStateSetterArgs,
  FormStatus,
} from '../types/appTypes';

export type UseFormArgs<T> = {
  initialFields: T;
  initialStatus?: FormStatus;
};

export function useForm<T>({
  initialFields,
  initialStatus = FormStatus.Pure,
}: UseFormArgs<T>): FormAndFieldsState<T> {
  const [fields, setFields] = useState<T>(initialFields);
  const [formState, setFormState] = useState<FormState>({
    status: initialStatus,
    error: null,
  });

  const setState: FormStateSetter = ({
    status,
    error = undefined,
  }: FormStateSetterArgs) => {
    if (error === undefined) {
      setFormState((pv) => {
        return { ...pv, status };
      });
    } else {
      setFormState({ status, error });
    }
  };

  return { fields, formState, setFields, setFormState: setState };
}
